export default __webpack_public_path__ + "img/d7d1cb44ba35d883936d87fd6865a1f4.png";